import { combineReducers } from 'redux';
import scheduleGetReducer from './scheduleGetReducer';
import reservationConfirmReducer from './reservationConfirmReducer';
import scheduleReservationStateReducer from './scheduleReservationStateReducer';
import scheduleReservationPostReducer from './scheduleReservationPostReducer';

const index = combineReducers({
  scheduleGet: scheduleGetReducer,
  getReservationConfirmReducer: reservationConfirmReducer,
  scheduleReservationState: scheduleReservationStateReducer,
  scheduleReservationPost: scheduleReservationPostReducer,
});

export default index;
